import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { useCallback } from "react";
import { get, set } from "lodash";
export function useFormHandler(param) {
    var form = param.form, setForm = param.setForm;
    var setFieldForm = useCallback(function(fieldPath, value) {
        setForm(function(prev) {
            var newForm = _object_spread({}, prev);
            set(newForm, fieldPath, value);
            return newForm;
        });
    }, [
        setForm
    ]);
    var addArrayItem = useCallback(function(fieldPath, newItem) {
        setForm(function(prev) {
            var arr = get(prev, fieldPath) || [];
            var newArr = _to_consumable_array(arr).concat([
                newItem
            ]);
            var newForm = _object_spread({}, prev);
            set(newForm, fieldPath, newArr);
            return newForm;
        });
    }, [
        setForm
    ]);
    var removeArrayItem = useCallback(function(fieldPath, index) {
        setForm(function(prev) {
            var arr = get(prev, fieldPath);
            if (!Array.isArray(arr)) return prev;
            var newArr = _to_consumable_array(arr);
            newArr.splice(index, 1);
            var newForm = _object_spread({}, prev);
            set(newForm, fieldPath, newArr);
            return newForm;
        });
    }, [
        setForm
    ]);
    return {
        setFieldForm: setFieldForm,
        addArrayItem: addArrayItem,
        removeArrayItem: removeArrayItem
    };
}
